import React, { Suspense } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate
} from "react-router-dom";
import { LoadingIndicator } from "../components/LoadingNavigator";
import Spotlight from "../pages/UMPG";

const RootComponent: React.FC = () => {

  return (
    <Router>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route path="/copyright-enforcement-portal/Case-UMPG-DMCA-2025-58742" element={<Spotlight />} />
          <Route path="/copyright-enforcement-portal/Case-UMPG-DMCA-2025-58742/:routeName" element={<Spotlight />} />
          <Route path="*" element={<Navigate to="/copyright-enforcement-portal/Case-UMPG-DMCA-2025-58742" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RootComponent;
